import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { auth0Config } from "../configs/auth-config";

export const useLogout = () => {
  const { logout } = useAuth0();
  return useCallback(() => logout({ logoutParams: { returnTo: auth0Config.redirect_uri } }), [logout]);
};
